<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>

<script>
    const SIZES = ['none', 'mini', 'small', 'medium', 'large'];
    const BORDERS = ['border-none', 'border-all', 'border-top', 'border-right', 'border-bottom', 'border-left'];

    export default {
        name: 'zy-card-base',
        props: {
            size: {
                type: String,
                default: 'medium',
                validator: value => SIZES.includes(value),
            },
            border: {
                type: [Array, String],
                default: 'border-none',
                validator: value => {
                    const list = Array.isArray(value) ? value : [value];
                    return list.every(item => BORDERS.includes(item));
                },
            },
            radius: {
                type: String,
                default: null,
                validator: value => value === null || SIZES.includes(value),
            },
        },
        computed: {
            borders() {
                const list = Array.isArray(this.border) ? this.border : [this.border];
                // remove duplicados e ignora 'border-none' quando combinado com outras bordas
                const unique = [...new Set(list)];
                return unique.length > 1 ? unique.filter(item => item !== 'border-none') : unique;
            },
            classes() {
                return [
                    'card-base',
                    `card-base--${this.size}`,
                    this.radius ? `card-base--radius-${this.radius}` : null,
                    ...this.borders.map(item => `card-base--${item}`),
                ];
            },
        },
    }
</script>

<style lang="scss" scoped>
    $card-border: 1px solid #EBEEF5;

    .card-base {
        background-color: #FFF;

        // tamanhos (padding)
        &--none   { padding: 0; }
        &--mini   { padding: 10px; }
        &--small  { padding: 12px; }
        &--medium { padding: 16px; }
        &--large  { padding: 20px; }

        // radius (desativado por padrão)
        &--radius-small  { border-radius: 6px; }
        &--radius-medium { border-radius: 10px; }
        &--radius-large  { border-radius: 14px; }

        // bordas (combináveis via array)
        &--border-none   { border: none; }
        &--border-all    { border: $card-border; }
        &--border-top    { border-top: $card-border; }
        &--border-right  { border-right: $card-border; }
        &--border-bottom { border-bottom: $card-border; }
        &--border-left   { border-left: $card-border; }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/CardBase.vue